<form no-validate (ngSubmit)="submit(form)" [formGroup]="form" autocomplete="off">
    <notification *ngIf="error" type="error">{{error}}</notification>
    <ng-container *ngFor="let part of objectKeys(config);">
        <ng-container *ngIf="config[part].hasGroup || config[part].hasTemplate">
            <ng-container [ngTemplateOutlet]="this[part]"
                          [ngTemplateOutletContext]="{ info: config[part] }"></ng-container>
        </ng-container>
    </ng-container>

    <ng-template #text let-info="info">
        <h2 class="form-title">{{ Yii.t('wui-shared-js', 'Recherche libre') }}</h2>
        <div [hidden]="isGlobalSearch">
            <div class="fieldset-sep search-ctn flex sep-bottom">
                <ng-container *ngFor="let rooming of getSegments().controls; let i = index;">

                    <text-field [group]="getSegments().controls[i].get('property')"
                                class="search ctn flex-4"
                                icon="icon"
                                controlName="text"
                                [placeholder]="Yii.t('wui-shared-js', 'Recherche libre')">
                        <fa-icon [icon]="iconSearch" class="icon-container"></fa-icon>
                    </text-field>
                    <text-field [group]="getSegments().controls[i].get('property')"
                                class="search ctn flex-4 locationText"
                                icon="icon"
                                controlName="locationName"
                                [placeholder]="Yii.t('wui-shared-js', 'Lieu')">
                        <fa-icon [icon]="iconSearch" class="icon-container"></fa-icon>
                    </text-field>
                    <span #locationNameField class="geopositionMarker"
                          *ngIf="isGeopositionSet()">
                    <i class="fa fa-map-marker" title="{{geopositionLabel}}"></i>
                </span>
                </ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #address let-info="info">
        <div [hidden]="isGlobalSearch" class="ctn address-ctn left">
            <address-fieldset [group]="form.get('address')"
                              [config]="info"></address-fieldset>
        </div>
    </ng-template>

    <ng-template #filters>
        <div *permissionIf="'iqbh.searchForm.keyword.use'" class="flex sep-bottom sep-top">
            <ng-container *ngFor="let rooming of getSegments().controls; let i = index;">
                <div class="ctn flex-1 sep-right">
                    <h2 class="form-title">{{ Yii.t('wui-shared-js', 'Mots-clés') }}</h2>
                    <multiselect [fieldConfig]="getKeywordConfig(i)"
                                 [options]="tagsList"
                                 [disabled]="tagsList.length === 0"></multiselect>
                </div>


                <div class="ctn flex-1">
                    <ng-container *permissionIf="permissions.SHARED_HOST_SHOW">
                        <h2 class="form-title">{{ Yii.t('wui-shared-js', 'Sources') }}</h2>
                        <multiselect *ngIf="hostsList?.length"
                                     [fieldConfig]="getHostConfig(i)"
                                     [options]="hostsList"></multiselect>
                    </ng-container>

                </div>
            </ng-container>
        </div>
    </ng-template>
    <ng-template #map>
        <ng-container *ngIf="hasRightToShowMap">
            <div [hidden]="isGlobalSearch" *permissionIf="'iqbh.searchForm.geoposition.use'" class="sep-top sep-bottom">
                <btnForm styleType="actionLink" formType="button" (click)="toggleMap()">
                    {{ showMap ? Yii.t('wui-iqbh-js', 'Fermer la carte') : Yii.t('wui-iqbh-js', 'Affiner la recherche avec la carte') }}
                    <fa-icon [icon]="showMap ? iconUp : iconDown"></fa-icon>
                </btnForm>
                <iqbh-map *ngIf="showMap || (showMap && geoposition)"
                          #searchMap
                          [defaultSearch]="searchInput"
                          [geoposition]="geoposition"
                          [config]="mapConfig"
                          (onGetGeoposition)="getGeoposition($event)"></iqbh-map>
            </div>
        </ng-container>
    </ng-template>


    <ng-template #segment let-info="info">
        <div [hidden]="isGlobalSearch || isUnitSearch" class="ctn segment-ctn">
            <segment-fieldset [group]="form.get('segment')" [config]="info"></segment-fieldset>
        </div>
    </ng-template>

    <ng-template #quantity let-info="info">
        <div class="ctn">
            <div class="quantities">

                <quantity-fieldset
                        [group]="form.get('quantity')"
                        [repartition]="getRooming()"
                        [config]="info"
                        [readOnlyTravellers]="hasTravellers()"></quantity-fieldset>
            </div>

            <div *ngIf="(getChild().controls.length > 0 || getInfant().controls.length > 0) && !hasTravellers()"
                 class="ages"
                 [formGroup]="form">
                <div *ngIf="getChild().controls.length > 0"
                     class="children"
                     formArrayName="child">
                    <div *ngFor="let childAges of getChild().controls; let i = index;"
                         class="child-age sep-right">
                        {{ wording.child }} {{ i + 1 }}
                        <number class="field-sep fix-width-1"
                                [labelPosition]="labelPosition"
                                [fieldConfig]="{
                formGroup: childAges,
                formControlName: 'age',
                min: travellerInformations.child.age.min,
                max: travellerInformations.child.age.max,
                label: wording.adt,
                fixed: 0
            }"></number>
                    </div>
                </div>
                <div *ngIf="getInfant().controls.length > 0" class="infants" formArrayName="infant">
                    <div *ngFor="let infantAges of getInfant().controls; let i = index;"
                         class="infant-age sep-right">
                        {{ wording.infant }} {{ i + 1 }}
                        <number class="field-sep fix-width-1"
                                [labelPosition]="labelPosition"
                                [fieldConfig]="{
                                    formGroup: infantAges,
                                    formControlName: 'age',
                                    min: travellerInformations.infant.age.min,
                                    max: travellerInformations.infant.age.max,
                                    fixed: 0
                                }"></number>
                    </div>
                </div>
            </div>
            <div class="negative-top">
                <btnForm styleType="actionLink" formType="button" (click)="dispatchingIsOpen = !dispatchingIsOpen">
                    {{ dispatchingIsOpen ? Yii.t('wui-iqbh-js', 'Masquer la répartition') : Yii.t('wui-iqbh-js', 'Voir la répartition') }}
                    <fa-icon [icon]="dispatchingIsOpen ? iconUp : iconDown"></fa-icon>
                </btnForm>
            </div>


            <span *ngIf="errorIsReady && getRepartitionErrors() && getRepartitionErrors() !== ''"
                  class="form-error-flux">
                {{ getRepartitionErrors() }}
            </span>
        </div>
    </ng-template>

    <ng-template #rooming let-info="info">
        <span [hidden]="!dispatchingIsOpen">
            <ng-container *ngFor="let rooms of getRooming().controls; let i = index;">
                <rooming-fieldset [group]="getRooming().controls[i]" [config]="info"></rooming-fieldset>
            </ng-container>
        </span>
    </ng-template>

    <ng-template #advancedFilters let-info="info">
        <ng-container>
            <div *ngIf="ratingsConfig" class="rating">
                <btnForm styleType="actionLink" formType="button" (click)="showAdvancedFilters = !showAdvancedFilters">
                    {{ showAdvancedFilters ? Yii.t('wui-iqbh-js', 'Moins de classements') : Yii.t('wui-iqbh-js', 'Plus de classements') }}
                    <fa-icon [icon]="showAdvancedFilters ? iconLeft : iconRight"></fa-icon>
                </btnForm>


                <div>
                    <ng-container *permissionIf="'iqbh.searchForm.additional.standardisationBody.use'">
                        <rating-field *ngIf="ratingsConfig
                                                && fieldConfig
                                                && ratingsConfig?.standardisationBody?.exist
                                                && (showAdvancedFilters || ratingsConfig.standardisationBody.visible)"
                                      class="sep-right"
                                      [fieldConfig]="fieldConfig.standardisationBody"
                                      [numberOfStars]="ratingsConfig.standardisationBody.numberOfStars"></rating-field>
                    </ng-container>
                    <ng-container *permissionIf="'iqbh.searchForm.additional.traveller.use'">
                        <rating-field *ngIf="ratingsConfig
                                        && fieldConfig
                                        && ratingsConfig?.traveller?.exist
                                        && (showAdvancedFilters || ratingsConfig.traveller.visible)"
                                      class="sep-right"
                                      [fieldConfig]="fieldConfig.traveller"
                                      [numberOfStars]="ratingsConfig.traveller.numberOfStars"></rating-field>
                    </ng-container>
                    <ng-container *permissionIf="'iqbh.searchForm.additional.brand.use'">
                        <rating-field *ngIf="ratingsConfig
                                                && fieldConfig
                                                && ratingsConfig?.brand?.exist
                                                && (showAdvancedFilters || ratingsConfig.brand.visible)"
                                      class="sep-right"
                                      [fieldConfig]="fieldConfig.brand"
                                      [numberOfStars]="ratingsConfig.brand.numberOfStars"
                                      (click)="onBrandRatingChange()"
                        ></rating-field>
                    </ng-container>
                    <ng-container *permissionIf="'iqbh.searchForm.additional.referenceHotels.use'">
                        <div class="referencedHotel"
                             *ngIf="ratingsConfig
                                    && ratingsConfig?.brandCheckbox?.exist
                                    && (showAdvancedFilters || ratingsConfig.brandCheckbox.visible)">
                            <p-checkbox #brandCheckbox
                                        [(ngModel)]="brandStateChecked"
                                        [ngModelOptions]="{standalone: true}"
                                        [binary]="true"
                                        [label]="wording.referencedHotel"
                                        (click)="onBrandCheckboxChange()"
                            ></p-checkbox>
                        </div>
                    </ng-container>
                    <p-checkbox *permissionIf="'shared.stay.quoteWithFees.view'"
                                [(ngModel)]="isOnlyRefundable"
                                [ngModelOptions]="{standalone: true}"
                                [binary]="true"
                                [label]="wording.isOnlyRefundable"
                    ></p-checkbox>

                </div>
            </div>
        </ng-container>
    </ng-template>
    <div [hidden]="isGlobalSearch || isUnitSearch">
        <div class="ctn ctn-right">
            <btnForm styleType="actionDo"
                     formType="button"
                     (click)="reset()">{{Yii.t('wui-shared-js', 'Réinitialiser')}}
            </btnForm>

            <btnForm class="submit-btn"
                     styleType="actionPrincipal"
                     formType="submit"
                     [disabled]="form.invalid"
            >{{Yii.t('wui-shared-js', 'Rechercher')}}

            </btnForm>

        </div>
    </div>
</form>
